// Bezpečné generovanie UUID aj mimo "secure context".
//
// crypto.randomUUID() je dostupné LEN v secure context (HTTPS alebo localhost).
// Pri otvorení appky cez obyčajné http://<IP> je crypto.randomUUID undefined a
// pád "crypto.randomUUID is not a function" zhodí celý React render.
//
// Fallback používa crypto.getRandomValues(), ktoré funguje aj v NEzabezpečenom
// kontexte (http://IP), a vytvorí štandardný UUID v4.
export function newUuid() {
  const c = (typeof crypto !== 'undefined' && crypto)
    || (typeof window !== 'undefined' && (window.crypto || window.msCrypto));

  if (c && typeof c.randomUUID === 'function') {
    return c.randomUUID();
  }

  if (c && typeof c.getRandomValues === 'function') {
    const b = new Uint8Array(16);
    c.getRandomValues(b);
    b[6] = (b[6] & 0x0f) | 0x40; // verzia 4
    b[8] = (b[8] & 0x3f) | 0x80; // variant 10xx
    const h = [];
    for (let i = 0; i < 16; i++) h.push(b[i].toString(16).padStart(2, '0'));
    return `${h[0]}${h[1]}${h[2]}${h[3]}-${h[4]}${h[5]}-${h[6]}${h[7]}-${h[8]}${h[9]}-${h[10]}${h[11]}${h[12]}${h[13]}${h[14]}${h[15]}`;
  }

  // Krajný fallback (nemalo by nastať) — bez crypto.
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (ch) => {
    const r = Math.floor(Math.random() * 16);
    const v = ch === 'x' ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
}
